<template>
  <BasicLayout v-slot:default="slotProps">
    <div
      v-if="slotProps.order"
      class="page"
    >
      <div class="page__content">
        <div class="page__content-wrapper centered">
          <h2>Jetzt Finanzierung beauftragen</h2>

          <p class="sub-title-text">
            Sie werden mit klicken auf den Reiter „Jetzt Finanzierung beantragen“ 
            zu unserem Partner der Bank11 weitergeleitet. Sobald
            Sie dort alles fertig eingetragen haben, werden Sie wieder zu uns
            zurückgeleitet und erhalten via Mail zeitnah eine Rückmeldung über
            den Anfrage-Status Ihrer Finanzierung. Dies kann zwischen 2 - 24
            Stunden dauern, bis die Bank hierzu eine Rückmeldung gibt.
          </p>
          <button
            type="button"
            @click="goToBankAgreements(slotProps.order.token)"
          >
            Jetzt Finanzierung beantragen
          </button>
          <p class="sub-title-text no-space">
            Sollten Sie technische Probleme mit der Finanzierungsanfrage haben,
            oder Unterstützung bei der Eingabe benötigen, so melden Sie sich
            gerne telefonisch bei uns unter:
            <br />
            <a href="tel:02119462550">Tel. 0211 94 62 550</a>
            <br />
            (Montag bis Freitag zwischen 08:30 und 17:00)
          </p>
        </div>
      </div>
    </div>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../components/layout/BasicLayout";
import { getRedirectUrl } from "@/api/checkout";

export default {
  components: {
    BasicLayout,
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 520;
    },
    isDesktop() {
      return window.innerWidth > 990;
    }
  },
  methods: {
    goToBankAgreements(token) {
      getRedirectUrl(token).then((res) => {
        window.location.replace(res.redirect_url);
      });
    }
  },

};
</script>

<style lang="scss" scoped>
.page__content {
  margin-right: 0;
}
.page__content-wrapper {
  border-radius: 20px;
  padding: 20px;
  margin: 0 20px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);

  &.centered {
    text-align: center;
  }
}

.page .sub-title-text.no-space {
  margin-bottom: 0;
}

button {
  position: relative;
  max-width: 400px;
  display: block;
  width: 100%;
  padding: 15px 10px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  background-color: $red;
  color: $white;
  transition: all 0.5s;
  border-radius: 50px;
  margin-bottom: 40px;
  margin-right: auto;
  margin-left: auto;

  &:after {
    @include icon("\f105", $white, 18px);
  }
  &:hover,
  &:focus,
  &:active {
    background: $darkgray;
  }
}

.order-details {
  h2 {
    padding: 0.9375rem 0.625rem 0;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }
  h3 {
    padding: 0 0.625rem;
    margin-bottom: 0.3125rem;
    font-size: 0.75rem;
  }
  &__delivery {
    margin: 0 0.625rem;
    padding: 0.625rem;
    border: 0.0625rem solid #e5e5e5;
    font-size: 0.8125rem;
    line-height: 1rem;
  }
  @include breakpoint(tablet) {
    max-width: 44.375rem;
    margin: 0 auto;
    padding: 0 1.875rem;
    background-color: #e5e5e5;
    &__content {
      background-color: $white;
    }
    h2 {
      padding: 0.9375rem 1.875rem 0;
    }
    h3 {
      padding: 0 1.875rem;
    }
    &__delivery {
      margin: 0 1.875rem 1.25rem;
    }
  }
  @include breakpoint(desktop) {
    padding: 0;
    h2 {
      font-size: 30px;
      padding-top: 3rem;
    }
    h3 {
      font-size: 0.875rem;
    }
    p {
      font-size: 1rem;
      line-height: 24px;
    }
    &__delivery {
      font-size: 0.875rem;
      padding: 1rem;
    }
  }
}
</style>
